import { useEffect, useId, useRef, type ReactNode } from "react";
import { X } from "lucide-react";
import { IconButton } from "./Button";

export function Drawer({
  title,
  subtitle,
  onClose,
  children,
  footer,
}: {
  title: string;
  subtitle?: ReactNode;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
}) {
  const heading = useRef<HTMLHeadingElement>(null);
  const titleId = useId();
  useEffect(() => {
    heading.current?.focus();
  }, [title]);
  return (
    <aside
      aria-labelledby={titleId}
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          e.stopPropagation();
          onClose();
        }
      }}
      className="flex min-h-0 w-drawer flex-none flex-col border-l border-divider bg-surface max-compact:absolute max-compact:inset-y-0 max-compact:right-0 max-compact:z-overlay max-compact:shadow-pop"
    >
      <div className="flex items-start gap-2.5 border-b border-divider px-[18px] pt-3.5 pb-3">
        <div className="min-w-0">
          <h2 id={titleId} ref={heading} tabIndex={-1} className="m-0 text-xl font-semibold">
            {title}
          </h2>
          {subtitle ? <div className="mt-0.5 text-md text-muted">{subtitle}</div> : null}
        </div>
        <IconButton label="Close" size="sm" className="ml-auto" onClick={onClose}>
          <X size={14} strokeWidth={1.8} aria-hidden="true" />
        </IconButton>
      </div>
      <div
        tabIndex={0}
        className="min-h-0 flex-1 overflow-auto px-[18px] pt-3.5 pb-[22px] focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-focus"
      >
        {children}
      </div>
      {footer ? <div className="border-t border-divider px-[18px] py-2.5 text-md text-muted">{footer}</div> : null}
    </aside>
  );
}
